<template>
    <router-link :to="to" class="sip-report-banner">
        <span class="sip-report-banner__well" aria-hidden="true">
            <admin-icon :name="icon" :size="18"></admin-icon>
        </span>
        <span class="sip-report-banner__copy">
            <span class="sip-report-banner__title">{{ title }}</span>
        </span>
        <span class="sip-report-banner__action">
            <span class="sip-report-banner__view">{{ trans('general.view') }}</span>
            <admin-icon name="chevron" :size="14"></admin-icon>
        </span>
    </router-link>
</template>

<script>
    export default {
        name: 'ReportHubBanner',
        props: {
            to: {
                type: String,
                required: true,
            },
            icon: {
                type: String,
                default: 'file-text',
            },
            title: {
                type: String,
                required: true,
            },
        },
    };
</script>
